// @flow

import type { Plan } from '@zapier/common-utils';

const getPlanFeatures = (plan: Plan, previous: ?Plan) => ({
  featuresTag:
    previous && previous.amount
      ? `Everything in ${previous.name}, plus`
      : 'Features include',
});

export default (
  currentPlanId: number,
  plans: Array<Plan> = [],
  isFall2019Pricing: boolean = false
): Array<Plan> => {
  return plans.map((plan, i, list) => {
    const planFeatures = getPlanFeatures(plan, i > 0 ? list[i - 1] : null);

    let selectedTaskLimitVariant;
    let selectedVariantInterval;

    if (isFall2019Pricing) {
      selectedTaskLimitVariant = plan.taskLimitVariants.find(
        variant =>
          variant.intervals.filter(interval => interval.id === currentPlanId)
            .length > 0
      );

      selectedVariantInterval =
        selectedTaskLimitVariant &&
        selectedTaskLimitVariant.intervals.find(
          interval => interval.id === currentPlanId
        );
    }

    const isCurrentPlan =
      !!selectedTaskLimitVariant || currentPlanId === plan.id;

    if (isFall2019Pricing && !selectedTaskLimitVariant) {
      selectedTaskLimitVariant = plan.taskLimitVariants[0];
    }

    return {
      ...plan,
      ...planFeatures,
      actions: selectedTaskLimitVariant
        ? selectedTaskLimitVariant.tasks
        : plan.tasks,
      amount: selectedVariantInterval
        ? selectedVariantInterval.monthlyAmount
        : plan.amount,
      isCurrentPlan,
      selectedTaskLimitVariant,
      tasks: selectedTaskLimitVariant
        ? selectedTaskLimitVariant.tasks
        : plan.tasks,
    };
  });
};
